import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { userApi } from '../services/api';

export default function PrivateRoute({ children }) {
  const [status, setStatus] = useState('checking'); // checking | ok | fail

  useEffect(() => {
    userApi.getMe()
      .then(() => setStatus('ok'))
      .catch(() => {
        localStorage.clear();
        setStatus('fail');
      });
  }, []);

  if (status === 'checking') {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Spin size="large" /></div>;
  }
  return status === 'ok' ? children : <Navigate to="/login" />;
}
